import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { RoutesEnum } from '@/enums/routes.enum';

export const Wrapper = styled('div')(({ theme }) => {
  const { pathname } = useLocation();
  return {
    backgroundColor: theme.colors.darkBlue,
    padding: pathname === RoutesEnum.help ? '14px 14px 30px' : '14px',
  };
});
export const WrapperInner = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
});
export const Menu = styled('img')({
  paddingLeft: '15px',
  position: 'absolute',
  left: '10px',
});
export const BurgerButton = styled('button')({
  position: 'absolute',
  background: 'none',
  border: 'none',
  left: '0',
  cursor: 'pointer',
  padding: '0px',
  margin: '0px',
});
export const InfoButton = styled('button')({
  position: 'absolute',
  background: 'none',
  border: 'none',
  right: '0',
  cursor: 'pointer',
  padding: '0px',
  margin: '0px',
});
export const ImageLogo = styled('img')({
  width: '140px',
  height: '40px',
});
